import { SubscriptionName } from '@anm/api/modules/subscription';
import FormHelperText from '@anm/components/form/FormHelperText';
import RedeemCouponForm, { RedeemCouponFormFields } from '@anm/components/form/RedeemCouponForm';
import {
  AppsumoHigherPlanMessage,
  RedeemCouponFormText,
  RedeemCouponFormWrapper
} from '@anm/components/subscription/current-plan/CurrentAppSumoPlan/Wrapper';
import getDisplayPlanName from '@anm/helpers/subscription/getDisplayPlanName';
import isSubscriptionHighPlan from '@anm/helpers/subscription/isHighPlanSubscription';
import usePageParams from '@anm/hooks/usePageParams';
import { useCallback, FC } from 'react';

import CardPlan from '../CardPlan';

import UpgradeToHightPlan, { UpgradeToHightPlanProps } from './UpgradeToHightPlan';

export type CurrentAppSumoPlanProps = UpgradeToHightPlanProps & {
  plan: SubscriptionName;
  submitError?: string;
  onRedeem: (coupon: string) => void;
};

const CurrentAppSumoPlan: FC<CurrentAppSumoPlanProps> = ({ plan, hasUserCard, submitError, onConfirm, onRedeem }) => {
  const isHightPlan = isSubscriptionHighPlan(plan);
  const { code: coupon } = usePageParams();
  const handleSubmit = useCallback(({ coupon }: RedeemCouponFormFields) => onRedeem(coupon), []);

  return (
    <CardPlan plan={getDisplayPlanName(plan)} periodName="Plan" description="AppSumo Lifetime">
      {isHightPlan ? (
        <AppsumoHigherPlanMessage>
          You've already got the highest possible AppSumo plan. Smart choice!
        </AppsumoHigherPlanMessage>
      ) : (
        <>
          <RedeemCouponFormText>Redeem one more AppSumo code to upgrade to Business plan:</RedeemCouponFormText>
          <RedeemCouponFormWrapper>
            <RedeemCouponForm
              placeholder="Enter your AppSumo code here"
              initialValues={{ coupon }}
              onSubmit={handleSubmit}
            />
          </RedeemCouponFormWrapper>
          {!isHightPlan && <UpgradeToHightPlan hasUserCard={hasUserCard} onConfirm={onConfirm} />}
          {submitError && <FormHelperText variant="static-left">{submitError}</FormHelperText>}
        </>
      )}
    </CardPlan>
  );
};
export default CurrentAppSumoPlan;
